import { Component, Injector, ElementRef } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  BaseResourceFormComponent, Pagamento, LoginPublico,
  FuncaoService, GlobalService, DateFormatPipe
} from 'eddydata-lib';
import { DatePipe } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import { ContaBancariaService } from '../../conta-bancaria/service/conta-bancaria.service';
import { LiquidacaoService } from '../../../contabil/liquidacao/service/liquidacao.service';
import { PagamentoService } from '../service/pagamento.service';

@Component({
  selector: 'app-pagamento-shw',
  templateUrl: './pagamento-shw.component.html'
})
export class PagamentoShwComponent extends BaseResourceFormComponent<Pagamento, LoginPublico> {

  /**
   * Declaração de variáveis
   */
  private pagina: string;
  private data1: string;
  private data2: string;
  private filtro: string;

  private datepipe: DatePipe;

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    protected funcaoService: FuncaoService,
    protected globalService: GlobalService,
    protected contaService: ContaBancariaService,
    protected liquidacaoService: LiquidacaoService,
    protected pagamentoService: PagamentoService) {
    super(new Pagamento(), injector, Pagamento.converteJson, pagamentoService);
    this.datepipe = new DatePipe('pt');
    this.activatedRoute.params.pipe(takeUntil(this.unsubscribe))
      .subscribe(params => {
        this.pagina = params['pagina'];
        this.data1 = params['data1'];
        this.data2 = params['data2'];
        this.filtro = params['filtro'];
      });
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================


  protected criarCamposForm(): void {
    this.entidadeForm = this.fb.group({
      id: [null],
      numero: [null, [Validators.required]],
      valor_pago: 0,
      valor_retido: [null, [Validators.required]],
      data_pagamento: [null, [Validators.required]],
      especie: [null, [Validators.required]],
      documento: [null, [Validators.required]],
      impresso: [null, [Validators.required]],
      historico: [null, [Validators.required, Validators.minLength(2)]],
      anulacao: [null, [Validators.required]],
      conta: [null, [Validators.required]],
      exercicio: this.fb.group({
        ano: [null, [Validators.required]],
      }),
      orgao: [null, [Validators.required]],
      liquidacao: this.fb.group({
        data_vencimento: [null, [Validators.required]],
        valor_liquidado: [null, [Validators.required]],
        parcela: [null, [Validators.required]],
        empenho: this.fb.group({
          numero: [null, [Validators.required]],
          exercicio: this.fb.group({
            ano: [null, [Validators.required]],
          }),
        })
      })
    });
    this.entidadeForm.disable();
  }

  protected parametrosExtras(): {} {
    return {
      relations: 'conta,conta.banco,liquidacao,liquidacao.empenho,liquidacao.empenho.favorecido,' +
        'liquidacao.empenho.subelemento,liquidacao.empenho.ficha,liquidacao.empenho.ficha.acao,exercicio,orgao'
    };
  }

  protected afterInit(): void {
    this.login.contraste = sessionStorage.getItem('contraste') === 'true';
  }

  protected campoFoco(): ElementRef {
    return null;
  }

  protected beforeSubmit(): void {
  }

  protected afterSubmit(entidade: Pagamento): void {
  }

  protected afterLoad() {
    this.entidade.data_pagamento = new DateFormatPipe().transform(this.entidade.data_pagamento, []);
  }

  public voltar() {
    const dt1 = this.datepipe.transform(this.data1, 'yyyy-MM-dd', 'GMT');
    const dt2 = this.datepipe.transform(this.data2, 'yyyy-MM-dd', 'GMT');
    if (!this.filtro || this.filtro === '') {
      this.router.navigate(['/pagamentos-orcamentarios/pesquisa', this.pagina, dt1, dt2]);
    } else {
      this.router.navigate(['/pagamentos-orcamentarios/pesquisa', this.pagina, dt1, dt2, this.filtro]);
    }
  }

}
